<template>
    <div class="student-layout">

        <student-nav/>

        <div class="app-wrap">
            <jet-banner />
            <slot></slot>
        </div>

    </div>
</template>

<script>
import StudentNav from "@/Components/StudentNav";
import JetBanner from "@/Jetstream/Banner";
import jQuery from "jquery";
export default {
    name: "StudentLayout",
    components: {JetBanner, StudentNav},

    mounted() {
        // Set the theme.
        jQuery(($) => {
            if( this.theme_background ){
                $('html')
                    .css({'background-image': `url(${this.theme_background})`})
                    .addClass('has-background');
            }
        });
    }
}
</script>

<style scoped>

</style>
